import React from 'react';

const ShareProgramContext = React.createContext({
  referralInfo: {},
  affiliateInfo: {},
  getGFReferralInfo: () => {},
});

export default ShareProgramContext;
